import _ from 'lodash';
import Vue, { VueConstructor } from 'vue';

export abstract class ModuleLoader {

    public static init(selector: string, component: VueConstructor<Vue>) {

        const domElement = document.querySelector('#' + selector);

        if (domElement) {

            const optionAsString = domElement.getAttribute('data-options') || '{}';

            const options = JSON.parse(optionAsString);

            new Vue({
                render: h => h(component, {
                    props: options
                }),
            }).$mount(domElement);
        }
    }

    public static initMany(selector: string, component: VueConstructor<Vue>) {

        const domElements = document.querySelectorAll('.' + selector);

        _.each(domElements, domElement => {

            if (!domElement) {

                return;
            }

            const optionAsString = domElement.getAttribute('data-options') || '{}';

            const options = JSON.parse(optionAsString);

            new Vue({
                render: h => h(component, {
                    props: options
                }),
            }).$mount(domElement);
        });
    }

    // Not sure if we're going to need this method, seems like our init methods are called after document is loaded?
    public static documentReady(callback: () => void) {

        if (document.readyState !== 'loading') { // in case the document is already rendered

            callback();

        } else if (document.addEventListener) { // modern browsers

            document.addEventListener('DOMContentLoaded', callback);

        } else { // IE <= 8

            if ((document as any).attachEvent) {

                (document as any).attachEvent('onreadystatechange', () => {

                    if (document.readyState === 'complete') {

                        callback();
                    }
                });
            }
        }
    }

}
